import React, { useEffect, useMemo, useRef, useState } from "react";

import img1 from "../../assets/AboutPage/AboutImage.png";
import img2 from "../../assets/Torturi_Macarons.png";
import img3 from "../../assets/CarouselSimple/Tort_emeraude_fistic_zmeura_slice.jpg";
import img4 from "../../assets/CarouselHome/CandyBar2.png";
import img5 from "../../assets/CarouselHome/2.png";
import img6 from "../../assets/CarouselSimple/Miel_dor_medovik_slice.jpg";
import img7 from "../../assets/CarouselHome/4.png";
import img8 from "../../assets/CarouselHome/6.png";
import img9 from "../../assets/CarouselHome/7.png";
import img10 from "../../assets/CarouselHome/8.png";
import img11 from "../../assets/CarouselHome/10.png";
import img12 from "../../assets/CarouselHome/11.png";

import {
  Wrap,
  Frame,
  Track,
  NavBtnLeft,
  NavBtnRight,
  Dots,
  Dot,
  Slide,
  Img,
  Overlay,
  Content,
  Title,
  SubTitle,
  CtaBtn,
} from "./HeroCarouselStyles";

export default function MenuHeroCarousel({ onCta }) {
  const trackRef = useRef(null);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  const slides = useMemo(
    () => [
      { src: img1, alt: "Ahava Cakes - slider 7" },

      {
        src: img2,
        alt: "Ahava Cakes - slider 1",
        title: "Tort Macarons Personalizat",
        ctaLabel: "Vezi produsul",
        onClick: () => onCta?.("cadouri_dulci"),
      },
      // {
      //   src: img1_1,
      //   alt: "Ahava Cakes - slider 1",
      //   title: "Tort Personalizat după preferințe",
      //   ctaLabel: "Vezi produsul",
      //   onClick: () => onCta?.("torturi"),
      // },

      { src: img3, alt: "Ahava Cakes - slider 7" },
      { src: img4, alt: "Ahava Cakes - slider 6" },
      { src: img5, alt: "Ahava Cakes - slider 4" },
      { src: img6, alt: "Ahava Cakes - slider 8" },
      { src: img7, alt: "Ahava Cakes - slider 10" },
      { src: img8, alt: "Ahava Cakes - slider 11" },
      { src: img9, alt: "Ahava Cakes - slider 2" },
    ],
    [],
  );

  const clamp = (n) => {
    const max = slides.length - 1;
    if (n < 0) return max;
    if (n > max) return 0;
    return n;
  };

  const goTo = (n) => {
    const next = clamp(n);
    setIdx(next);

    const el = trackRef.current;
    if (!el) return;

    const slideW = el.clientWidth;
    el.scrollTo({ left: slideW * next, behavior: "smooth" });
  };

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;

    const onScroll = () => {
      const w = el.clientWidth || 1;
      const i = Math.round(el.scrollLeft / w);
      setIdx(clamp(i));
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [slides.length]);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => goTo(idx + 1), 4200);
    return () => clearInterval(t);
  }, [idx, paused]);

  const active = slides[idx];

  return (
    <Wrap
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
    >
      <Frame>
        <Track ref={trackRef}>
          {slides.map((s, i) => {
            const hasCTA = !!(s.title || s.subtitle || s.href || s.onClick);

            return (
              <Slide key={s.src + i}>
                <Img src={s.src} alt={s.alt} loading="lazy" />
                <Overlay />

                {/* ✅ doar unde vrei tu */}
                {hasCTA && (
                  <Content>
                    {s.title && <Title>{s.title}</Title>}
                    {s.subtitle && <SubTitle>{s.subtitle}</SubTitle>}

                    {(s.href || s.onClick) && (
                      <CtaBtn type="button" onClick={s.onClick}>
                        {s.ctaLabel || "Vezi produsul"}
                      </CtaBtn>
                    )}
                  </Content>
                )}
              </Slide>
            );
          })}
        </Track>

        <NavBtnLeft
          type="button"
          aria-label="Înapoi"
          onClick={() => goTo(idx - 1)}
        >
          ‹
        </NavBtnLeft>
        <NavBtnRight
          type="button"
          aria-label="Înainte"
          onClick={() => goTo(idx + 1)}
        >
          ›
        </NavBtnRight>

        <Dots>
          {slides.map((_, i) => (
            <Dot
              key={i}
              type="button"
              aria-label={`Slide ${i + 1}`}
              $active={i === idx}
              onClick={() => goTo(i)}
            />
          ))}
        </Dots>
      </Frame>
    </Wrap>
  );
}
